/**
 * @ngdoc object
 * @name main
 * @description
 *
 */
angular
    .module('festzelt-os.documents.templates', [
        'ui.router',
        'festzelt-os.components',
        //'ngListView'
    ]);

require('./templates-routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/details-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/template-factory');
require('./workflows');

// Store
require('./store/template');



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/templates-module.js